<div #mapElement class="map" *ngIf="inlineMap"></div>

<p-dialog
  *ngIf="!inlineMap"
  [header]="address"
  [(visible)]="visible"
  [modal]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  (visibleChange)="onVisibleChange($event)"
  appendTo="body"
  styleClass="map-dialog"
>
  <div #mapElement class="map"></div>
</p-dialog>
